import React from 'react';
import classes from './Hamburger.css';

const hamburger = (props) => {

  const hamburgerClasses = [classes.Hamburger];
  const hamburgerBarClasses = [classes.HamburgerBar];

  if (props.openState) {
    hamburgerBarClasses.push(classes.Open);
  }

  return <div onClick={props.toggleDrawer} className={hamburgerClasses.join(' ')}>
    <div className={hamburgerBarClasses.join(' ')}></div>
  </div>
}

export default hamburger;


// WEBPACK FOOTER //
// ./src/components/Navigation/Navbar/Hamburger/Hamburger.jsx